function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translateFieldName, translate } from '../utils/helpers';
import { LANG } from '../utils/constant';
import BreadCrumbItem from './BreadCrumbItem';
import _isNaN from 'lodash/isNaN';

var BreadCrumbShop = /*#__PURE__*/function (_Component) {
  _inherits(BreadCrumbShop, _Component);

  var _super = _createSuper(BreadCrumbShop);

  function BreadCrumbShop() {
    var _this;

    _classCallCheck(this, BreadCrumbShop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getActiveSuppliers", function () {
      return _this.props.suppliers.find(function (supplier) {
        return supplier.id === parseInt(_this.props.objectifiedParameters.suppliers[0], 10);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveCertifications", function () {
      return _this.props.certifications.find(function (certification) {
        return certification.id === parseInt(_this.props.objectifiedParameters.certifications[0], 10);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getBreadCrumbLink", function (index) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return index !== _this.props.objectifiedParameters.category.length - 1 ? index === 0 ? "".concat(prefix, "/category/").concat(_this.props.objectifiedParameters.category[0]) : index === 1 ? "".concat(prefix, "/category/").concat(_this.props.objectifiedParameters.category[0], "+").concat(_this.props.objectifiedParameters.category[1]) : "".concat(prefix, "/category/").concat(_this.props.objectifiedParameters.category[0], "+").concat(_this.props.objectifiedParameters.category[1], "+").concat(_this.props.objectifiedParameters.category[2]) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "getBreadCrumbName", function (index) {
      if (index === 0) {
        return _this.props.categories[0][translateFieldName('name')];
      } else if (index === 1) {
        var categoryId = parseInt(_this.props.objectifiedParameters.category[1], 10);

        if (_isNaN(categoryId)) {
          return '';
        } else {
          var subCategory = _this.props.categories[0].sub_categories.find(function (category) {
            return category.id === parseInt(_this.props.objectifiedParameters.category[1], 10);
          });

          if (subCategory === undefined) {
            return;
          }

          return subCategory[translateFieldName('name')];
        }
      } else if (index === 2) {
        var subSubCategory = _this.props.categories[0].sub_categories[0].sub_sub_categories.find(function (category) {
          return category.id === parseInt(_this.props.objectifiedParameters.category[2], 10);
        });

        if (subSubCategory === undefined) {
          return;
        }

        return subSubCategory[translateFieldName('name')];
      } else {
        return '';
      }
    });

    return _this;
  }

  _createClass(BreadCrumbShop, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          categories = _this$props.categories,
          certifications = _this$props.certifications,
          loadingProduct = _this$props.loadingProduct,
          objectifiedParameters = _this$props.objectifiedParameters,
          search = _this$props.search,
          shopType = _this$props.shopType,
          family = _this$props.family;
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, !loadingProduct ? /*#__PURE__*/React.createElement("div", {
        className: "col-12 path d-flex"
      }, /*#__PURE__*/React.createElement("div", {
        className: "breadcrumb-home "
      }, /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/"),
        className: "main-txt-hover"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-home fa-1-5x main-txt ",
        "aria-hidden": "true"
      }))), shopType === 'category' && categories.length ? [/*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 0 + translate('products', 'produits'),
        link: "/page/categories",
        name: translate('Products', 'Produits')
      }), objectifiedParameters.category.map(function (category, index) {
        return /*#__PURE__*/React.createElement(BreadCrumbItem, {
          key: index.toString() + category.toString(),
          link: _this2.getBreadCrumbLink(index),
          name: _this2.getBreadCrumbName(index)
        });
      })] : null, shopType === 'certifications' && certifications.length && this.getActiveCertifications() !== undefined ? [/*#__PURE__*/React.createElement(BreadCrumbItem, {
        link: '/page/certifications',
        key: 0 + translate('Certifications'),
        name: translate('Certifications')
      }), /*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 3 + this.getActiveCertifications()[translateFieldName('name')],
        link: objectifiedParameters.category ? "/certifications/".concat(this.getActiveCertifications().id) : undefined,
        name: this.getActiveCertifications()[translateFieldName('name')]
      }), categories.length && objectifiedParameters.category ? objectifiedParameters.category.map(function (category, index) {
        return /*#__PURE__*/React.createElement(BreadCrumbItem, {
          key: index.toString() + category.toString(),
          link: _this2.getBreadCrumbLink(index, "/certifications/".concat(_this2.getActiveCertifications().id)),
          name: _this2.getBreadCrumbName(index)
        });
      }) : null] : null, shopType === 'search' ? [/*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 0 + translate('Search', 'Recherche'),
        name: translate('Search', 'Recherche')
      }), /*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 1 + search,
        link: objectifiedParameters.category ? "/search/".concat(search) : undefined,
        name: search
      }), categories.length && objectifiedParameters.category ? objectifiedParameters.category.map(function (category, index) {
        return /*#__PURE__*/React.createElement(BreadCrumbItem, {
          key: index.toString() + category.toString(),
          link: _this2.getBreadCrumbLink(index, "/search/".concat(search)),
          name: _this2.getBreadCrumbName(index)
        });
      }) : null] : null, shopType === 'families' && family !== null ? [/*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 0 + translate('families', 'familles'),
        link: "/".concat(LANG, "/").concat(translate('ino-lines', 'lignes-ino')),
        name: translate('INO Lines', 'Lignes INO'),
        insideRouter: false
      }), /*#__PURE__*/React.createElement(BreadCrumbItem, {
        key: 1 + family.family_id.toString(),
        link: "/families/".concat(family.family_id, "/suppliers/1"),
        name: family.slug
      })] : null) : null);
    }
  }]);

  return BreadCrumbShop;
}(Component);

BreadCrumbShop.propTypes = {
  categories: PropTypes.array,
  certifications: PropTypes.array,
  loadingProduct: PropTypes.bool,
  objectifiedParameters: PropTypes.object,
  search: PropTypes.string,
  shopType: PropTypes.string,
  suppliers: PropTypes.array,
  family: PropTypes.object
};
export default BreadCrumbShop;